export default __webpack_public_path__ + "assets/fonts/9400dbd219665365aa728467aee96301.woff";